import { useMutation } from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import { getLocalStorage } from '@/Utils/CommonUtils';

interface ValidateCouponParams {
  coupon_code: string;
  tournament_id?: number;
  plan_type?: string;
  duration_months?: number;
  source?: string; // e.g., 'renewal_page', 'checkout_page'
}

interface ValidateCouponResponse {
  valid: boolean;
  coupon?: {
    code: string;
    discount_type: string;
    discount_value: string;
    currency: string;
    valid_until?: string;
  };
  error?: string;
}

export default function useValidateCoupon(
  handleOnSuccess?: (data: ValidateCouponResponse) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation<ValidateCouponResponse, Error, ValidateCouponParams>(
    async params => {
      const token = await getLocalStorage('access_token');
      if (!token) {
        throw new Error('Authentication token not found');
      }

      const response = await ChessRestClient.post<ValidateCouponResponse>(
        'subscription/v1/validate-coupon/',
        params,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        },
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: error => {
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}
